import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function getSessionId() {
  let sid = localStorage.getItem("idealab_session");
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem("idealab_session", sid);
  }
  return sid;
}

export function saveAnswers(answers) {
  localStorage.setItem("idealab_answers", JSON.stringify(answers));
}

export function loadAnswers() {
  try {
    return JSON.parse(localStorage.getItem("idealab_answers") || "{}");
  } catch {
    return {};
  }
}

export function clearAnswers() {
  localStorage.removeItem("idealab_answers");
}
